<style lang="scss">
    .common-fuzzy {
        .ls-table-block {
            padding: 0;
            margin: 0;
        }

        .el-dialog__body {
            padding: 0 20px;
        }
        .ls-table {
            min-height: 350px;
        }
        .el-form-item {
            margin-bottom: 0;
        }
        .el-form-item__label {
            font-size: 14px;
            line-height: 40px;
        }
        .el-form-item__content {
            font-size: 12px;
            line-height: 40px;
            input {
                line-height: 24px;
                height: 24px;
            }
        }
    }
</style>
<template>
    <my-table ref="table" :cols="param.cols" :data="list" :loading="loading" :page-param="page" single hide-multiple
              @init="init" @refresh="getList" @pageChange="pageChange" @paramChange="paramChange"
              @cndClusterChange="cndClusterChange" @handleRowDbClickChange="handleDb">
        <template #left>
            <el-button type="warning" plain @click="handleDb({})">清空数据</el-button>
        </template>
    </my-table>
</template>

<script>
    // import axios from '@/util/api'
    // import help from '@/util/help'
    import tableMixin from '@/util/tableMixin'
    export default {
        mixins: [tableMixin],
        props: ['param', 'obj'],
        data() {
            return {
                api: {
                    list: '',   // 列表接口
                },
                cols: [],
                query: null,
                queryFunc: () => {},
            }
        },
        created() {
            this.api.list = this.param.api
            this.cols = this.param.cols.map(item => {
                item.viewList = true
                return item
            })

            if (this.param.query) {
                this.query = this.param.query
            }

            if (this.obj.query) {
                this.queryFunc = this.obj.query
            }

        },
        methods: {
            handleDb(data) {
                this.$emit('change', data)
            }
        }
    }
</script>
